import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

export const Footer = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const { t } = useLanguage();
  
  return (
    <footer 
      className={`${isHomePage ? 'text-white relative' : 'bg-secondary border-t border-border'} mt-auto`} 
      style={isHomePage ? { backgroundColor: '#000000' } : {}}
      data-testid="footer"
    >
      {/* Pattern Background - Homepage only */}
      {isHomePage && (
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `url('https://customer-assets.emergentagent.com/job_337353c4-cab4-46ce-9f12-02cfa3d402e5/artifacts/u3ohjz3m_pattern.png')`,
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: 0.10
          }}
        />
      )}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-20">
        {/* Center Content */}
        <div className="flex flex-col items-center">
          
          {/* Centered Navigation - Single Row */}
          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4">
            <Link to="/contact" className={`text-sm md:text-base font-light tracking-wide ${isHomePage ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-black'} transition-all`} style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
              {t('contactUs') || 'Contact Us'}
            </Link>
            <span className={`${isHomePage ? 'text-gray-500' : 'text-gray-400'}`}>•</span>
            <Link to="/how-to-apply" className={`text-sm md:text-base font-light tracking-wide ${isHomePage ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-black'} transition-all`} style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
              {t('howToApply') || 'How to Apply'}
            </Link>
            <span className={`${isHomePage ? 'text-gray-500' : 'text-gray-400'}`}>•</span>
            <Link to="/shipping-returns" className={`text-sm md:text-base font-light tracking-wide ${isHomePage ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-black'} transition-all`} style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
              {t('shippingReturns') || 'Shipping and Returns'}
            </Link>
            <span className={`${isHomePage ? 'text-gray-500' : 'text-gray-400'}`}>•</span>
            <Link to="/customs-duty" className={`text-sm md:text-base font-light tracking-wide ${isHomePage ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-black'} transition-all`} style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
              {t('customsDuty') || 'Customs / Duty Charges'}
            </Link>
            <span className={`${isHomePage ? 'text-gray-500' : 'text-gray-400'}`}>•</span>
            <Link to="/usa-delivery-duties" className={`text-sm md:text-base font-light tracking-wide ${isHomePage ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-black'} transition-all`} style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
              {t('usaDelivery') || 'USA and Delivery Duties'}
            </Link>
            <span className={`${isHomePage ? 'text-gray-500' : 'text-gray-400'}`}>•</span>
            <Link to="/terms-conditions" className={`text-sm md:text-base font-light tracking-wide ${isHomePage ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-black'} transition-all`} style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
              {t('termsConditions') || 'Terms and Conditions'}
            </Link>
          </div>
        </div>

        {/* Bottom - Copyright */}
        <div className={`border-t ${isHomePage ? 'border-gray-800' : 'border-border'} mt-16 pt-8 flex flex-col md:flex-row justify-center items-center gap-4 text-center`}>
          <p className={`text-base md:text-lg ${isHomePage ? 'text-white' : 'text-muted-foreground'}`}>
            © {new Date().getFullYear()} Ministripes UK. {t('allRightsReserved') || 'All rights reserved.'}
          </p>
          <span className={`hidden md:inline text-base md:text-lg ${isHomePage ? 'text-white' : 'text-muted-foreground'}`}>•</span>
          <span className={`text-base md:text-lg ${isHomePage ? 'text-white' : 'text-muted-foreground'}`}>
            Payment secured by Stripe
          </span>
        </div>

        {/* Legal Disclaimer - Very Bottom */}
        <div className="mt-8 pt-6 text-center">
          <p 
            className={`text-xs md:text-sm font-light tracking-wide ${isHomePage ? 'text-gray-400' : 'text-gray-500'} mb-4`}
            style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale' }}
          >
            <strong className={isHomePage ? 'text-gray-300' : 'text-gray-600'}>Legal Disclaimer:</strong>
          </p>
          <p 
            className={`text-xs md:text-sm font-light tracking-wide ${isHomePage ? 'text-gray-400' : 'text-gray-500'} leading-relaxed max-w-4xl mx-auto mb-4`}
            style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale' }}
          >
            Copyright © Ministripes UK - Vehicle Decal Specialists. All rights reserved.
            <br />
            Ministripes UK is an independent, non-franchised manufacturer and supplier of aftermarket replacement graphics and restoration parts.
          </p>
          <p 
            className={`text-xs md:text-sm font-light tracking-wide ${isHomePage ? 'text-gray-400' : 'text-gray-500'} leading-relaxed max-w-4xl mx-auto`}
            style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale' }}
          >
            All vehicle manufacturer names, logos, and model designations used on this website are the property of their respective trademark owners. Any reference to these trademarks or model names is strictly for descriptive and compatibility identification purposes only, and does not imply any affiliation, sponsorship, or endorsement by the vehicle manufacturer.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
